import { useEffect, useState } from "react";
import FavoriteButton from "src/pages/DashboardPage/acadia/components/FavoriteButton";
import DialogComponent from "src/components/DialogComponent";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import InputFilterSet from "src/components/InputFilterSet";
import TGButton from "src/components/ui/TGButton";
import SaveIcon from "src/components/ui-icons/SaveIcon";
import { useAppSelector } from "src/hooks/redux";
import { SelectedCurrentUser } from "src/modules/users/types";
import { selectCurrentUser } from "src/modules/users/selector";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import Loading from "src/components/Loading";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";
import { favoriteFiltersListName } from "src/api/config";

export const FavoriteButtonFilters = ({ filters, displayFilters, reRenderFilterSettings, setReRenderFilterSettings, filtersParams, type }: { filters: string, displayFilters: string, reRenderFilterSettings: boolean, setReRenderFilterSettings: any, filtersParams: any, type: string }) => {

    const [isSaved, setIsSaved] = useState(false);
    const [isFavorite, setIsFavorite] = useState<{ state: boolean; id: number | null }>({ state: false, id: null });
    const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);
    const [loading, setLoading] = useState(false);
    const [filterTitle, setFilterTitle] = useState("");
    const [defaultFilter, setDefaultFilter] = useState(false);
    const [sendFilters, setSendFilters] = useState<any>({});
    const [sendDisplayFilters, setSendDisplayFilters] = useState<any>({});
    const [sendFiltersParams, setSendFiltersParams] = useState<any>({});

    useEffect(() => {
        setLoading(true);
        if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
            getItemsRequest({ listName: favoriteFiltersListName, filters: { Author: currentUser.id, Type: type } }).then(results => {
                const favoriteFilters = [...results.items.filter((item: any) => item.MDFullFilters === filtersParams)];
                if (favoriteFilters.length > 0) {
                    setIsFavorite({
                        state: true,
                        id: favoriteFilters[0]['ID']
                    });
                } else {
                    setIsFavorite({ state: false, id: null });
                }
                setLoading(false);
            });
        }
    }, [reRenderFilterSettings, filtersParams, currentUser]);

    const toggleFavorite = () => {
        setLoading(true);
        closeDialog();
        if (!isFavorite.id) {
            getItemsRequest({ listName: favoriteFiltersListName, filters: { Author: currentUser.id, Type: type } }).then(results => {
                const filtersUser = [...results.items];
                if (filtersUser.length > 0) {
                    if (defaultFilter) {
                        let updateFilters: any = [];
                        filtersUser.forEach((filter: any) => {
                            updateFilters = [...updateFilters, {
                                ID: filter.ID,
                                DefaultFilter: false
                            }]
                        });
                        updateItemRequest({ listName: favoriteFiltersListName, body: updateFilters[0], bodyArr: updateFilters }).then(() => {
                            addItemRequest({
                                listName: favoriteFiltersListName,
                                body: {
                                    MDFilter: JSON.stringify(sendFilters),
                                    DisplayFilters: JSON.stringify(sendDisplayFilters),
                                    MDFullFilters: JSON.stringify(sendFiltersParams),
                                    Title: filterTitle,
                                    Type: type,
                                    DefaultFilter: defaultFilter,
                                    DocumentsFilter: JSON.stringify({})
                                },
                            }).then(id => {
                                setFilterTitle("");
                                setDefaultFilter(false);
                                setReRenderFilterSettings(!reRenderFilterSettings);
                                setLoading(false);
                            });
                        });
                    } else {
                        addItemRequest({
                            listName: favoriteFiltersListName,
                            body: {
                                MDFilter: JSON.stringify(sendFilters),
                                DisplayFilters: JSON.stringify(sendDisplayFilters),
                                MDFullFilters: JSON.stringify(sendFiltersParams),
                                Title: filterTitle,
                                Type: type,
                                DefaultFilter: defaultFilter,
                                DocumentsFilter: JSON.stringify({})
                            },
                        }).then(id => {
                            setFilterTitle("");
                            setDefaultFilter(false);
                            setReRenderFilterSettings(!reRenderFilterSettings);
                            setLoading(false);
                        });
                    }
                } else {
                    addItemRequest({
                        listName: favoriteFiltersListName,
                        body: {
                            MDFilter: JSON.stringify(sendFilters),
                            DisplayFilters: JSON.stringify(sendDisplayFilters),
                            MDFullFilters: JSON.stringify(sendFiltersParams),
                            Title: filterTitle,
                            Type: type,
                            DefaultFilter: defaultFilter,
                            DocumentsFilter: JSON.stringify({})
                        },
                    }).then(id => {
                        setFilterTitle("");
                        setDefaultFilter(false);
                        setReRenderFilterSettings(!reRenderFilterSettings);
                        setLoading(false);
                    });
                }
            });
        } else {
            deleteItemRequest({
                listName: favoriteFiltersListName,
                ID: isFavorite.id,
            }).then(() => {
                setFilterTitle("");
                setDefaultFilter(false);
                setReRenderFilterSettings(!reRenderFilterSettings);
                setLoading(false);
            })
        }
    }

    function openDialog() {
        setIsSaved(true);
    }

    function closeDialog() {
        setIsSaved(false);
        setFilterTitle("");
    }

    useEffect(() => {
        if (filters) {
            const tempFilters = { ...JSON.parse(filters) };
            tempFilters.hasOwnProperty('ReportEmployee') && delete tempFilters['ReportEmployee'];
            tempFilters.hasOwnProperty('AuthorEmailOWD') && delete tempFilters['AuthorEmailOWD'];
            tempFilters.hasOwnProperty('TestedEmployee') && delete tempFilters['TestedEmployee'];
            tempFilters.hasOwnProperty('DateForReport') && delete tempFilters['DateForReport'];
            setSendFilters({ ...tempFilters });
        }
    }, [filters]);

    useEffect(() => {
        if (displayFilters) {
            const tempFilters = { ...JSON.parse(displayFilters) };
            tempFilters.hasOwnProperty('ReportEmployee') && delete tempFilters['ReportEmployee'];
            tempFilters.hasOwnProperty('AuthorEmailOWD') && delete tempFilters['AuthorEmailOWD'];
            tempFilters.hasOwnProperty('TestedEmployee') && delete tempFilters['TestedEmployee'];
            tempFilters.hasOwnProperty('DateForReport') && delete tempFilters['DateForReport'];
            setSendDisplayFilters({ ...tempFilters });
        }
    }, [displayFilters]);

    useEffect(() => {
        if (filtersParams) {
            const tempFilters = { ...JSON.parse(filtersParams) };
            tempFilters.hasOwnProperty('ReportEmployee') && delete tempFilters['ReportEmployee'];
            tempFilters.hasOwnProperty('AuthorEmailOWD') && delete tempFilters['AuthorEmailOWD'];
            tempFilters.hasOwnProperty('TestedEmployee') && delete tempFilters['TestedEmployee'];
            tempFilters.hasOwnProperty('DateForReport') && delete tempFilters['DateForReport'];
            setSendFiltersParams({ ...tempFilters });
        }
    }, [filtersParams]);

    return (
        <>
            {filters &&
                <>
                    {loading &&
                        <FlexCol className="flex w-6 h-6">
                            <Loading />
                        </FlexCol> ||
                        <FavoriteButton isFavorite={isFavorite} onToggle={isFavorite.state && isFavorite.id ? toggleFavorite : openDialog} />
                    }
                    <DialogComponent open={isSaved} toggleDialog={closeDialog}>
                        <FlexCol className="w-[600px] shrink">
                            <FlexRow className="mb-9">
                                <h3 className="text-black">Назовите набор фильтров</h3>
                            </FlexRow>
                            <FlexRow className="mb-9">
                                <InputFilterSet initial={filterTitle} onChange={setFilterTitle} />
                            </FlexRow>
                            <FlexRow className="mb-9">
                                <div className="flex gap-[8px]">
                                    <button onClick={() => setDefaultFilter(!defaultFilter)} className="hover:cursor-pointer">
                                        <CustomRadio checked={defaultFilter} />
                                    </button>
                                    <span className="text-[#111928]">Установить по умолчанию</span>
                                </div>
                            </FlexRow>
                            <FlexRow className="justify-between px-10 pt-10 -mx-10 border-t">
                                <FlexCol>
                                    <TGButton onClick={closeDialog}>Отмена</TGButton>
                                </FlexCol>
                                <FlexCol>
                                    <TGButton color="bluedark" icon={<SaveIcon />} onClick={toggleFavorite}>
                                        Сохранить
                                    </TGButton>
                                </FlexCol>
                            </FlexRow>
                        </FlexCol>
                    </DialogComponent>
                </>
            }
        </>
    );
};
